import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mathAbs',
  standalone: true
})
export class MathAbsPipe implements PipeTransform {

  public transform(val: number): number {
    return Math.abs(val);
  }
}
